import React from 'react';

import { TableCell, TableFooter, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PreInscriptionSummaryHelper } from '../../../../helpers/pre-inscription-summary.helper';
import { IPreInscriptionSummary } from '../../../../types/pre-inscription-summary.type';

interface IProps {
  inscriptions: IPreInscriptionSummary[];
}

const PreInscriptionSummaryListFooter = React.memo(({ inscriptions }: IProps) => {
  const { t } = useTranslation();

  const { responseDa, afterRapo, responseRapo } =
    PreInscriptionSummaryHelper.calculateTotal(inscriptions);

  return (
    <TableFooter>
      <TableRow sx={{ '& td:not(:first-of-type)': { textAlign: 'center', fontWeight: 'bold' } }}>
        <TableCell sx={{ fontWeight: 'bold' }} colSpan={2} rowSpan={2}>
          {t('general.total')}
        </TableCell>

        <TableCell>{responseDa.accepted}</TableCell>
        <TableCell>{responseDa.refused}</TableCell>
        <TableCell>{responseDa.total}</TableCell>
        <TableCell>{afterRapo.accepted}</TableCell>
        <TableCell>{afterRapo.refused}</TableCell>
        <TableCell>{afterRapo.total}</TableCell>
        <TableCell>{responseRapo.accepted}</TableCell>
        <TableCell>{responseRapo.refused}</TableCell>
      </TableRow>

      <TableRow sx={{ '& td': { textAlign: 'center', fontWeight: 'bold' } }}>
        <TableCell>{responseDa.acceptedFraction}%</TableCell>
        <TableCell>{responseDa.refusedFraction}%</TableCell>
        <TableCell>100%</TableCell>
        <TableCell>{afterRapo.acceptedFraction}%</TableCell>
        <TableCell>{afterRapo.refusedFraction}%</TableCell>
        <TableCell>100%</TableCell>
        <TableCell>{responseRapo.acceptedFraction}%</TableCell>
        <TableCell>{responseRapo.refusedFraction}%</TableCell>
      </TableRow>
    </TableFooter>
  );
});

export default PreInscriptionSummaryListFooter;
